import React, {useEffect} from "react";
import { motion } from "framer-motion";
import Breadcrumb from "../Components/Breadcrumb";
import Cta from "../Components/Cta";

const CookiePolicy=()=>{
     const fadeUp = {
  hidden: {
    opacity: 0,
    y: 40,
    filter: "blur(8px)",
  },
  visible: {
    opacity: 1,
    y: 0,
    filter: "blur(0px)",
    transition: {
      duration: 0.7,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};

const stagger = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.08,
    },
  },
};

const itemVariant = {
  hidden: {
    opacity: 0,
    y: 30,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.55,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};

useEffect(() => {
    document.title =
      "Cookie Policy | ONBBITS";

    const metaDesc = document.querySelector("meta[name='description']");
    if (metaDesc) {
      metaDesc.setAttribute(
        "content",
        "Discover how ONBBITS uses cookies and similar technologies to improve website performance, security, analytics and user experience."
      );
    }

     const canonical = document.querySelector("link[rel='canonical']");
  if (canonical) {
    canonical.setAttribute("href", "https://onbbits.io/cookie-policy");
  }

  const ogTitle = document.querySelector("meta[property='og:title']");
  if (ogTitle) {
    ogTitle.setAttribute(
      "content",
      "Cookie Policy | ONBBITS"
    );
  }

    const ogDesc = document.querySelector("meta[property='og:description']");
  if (ogDesc) {
    ogDesc.setAttribute(
      "content",
      "Discover how ONBBITS uses cookies and similar technologies to improve website performance, security, analytics and user experience."
    );
  }

  const ogUrl = document.querySelector("meta[property='og:url']");
  if (ogUrl) {
    ogUrl.setAttribute("content", "https://onbbits.io/cookie-policy");
  }

    const ogImage = document.querySelector("meta[property='og:image']");
  if (ogImage) {
    ogImage.setAttribute(
      "content",
      "https://onbbits.io/Images/hero-img.webp"
    );
  }

    const twitterTitle = document.querySelector("meta[name='twitter:title']");
  if (twitterTitle) {
    twitterTitle.setAttribute(
      "content",
      "Cookie Policy | ONBBITS"
    );
  }

    const twitterDesc = document.querySelector(
    "meta[name='twitter:description']"
  );
  if (twitterDesc) {
    twitterDesc.setAttribute(
      "content",
      "Discover how ONBBITS uses cookies and similar technologies to improve website performance, security, analytics and user experience."
    );
  }

    const twitterImage = document.querySelector("meta[name='twitter:image']");
  if (twitterImage) {
    twitterImage.setAttribute(
      "content",
      "https://onbbits.io/Images/hero-img.webp"
    );
  }
  }, [])

    return(
        <>
         {/**BREADCRUMB */}
        <Breadcrumb title="Cookie Policy" />

        <motion.section
            className="policy-section container"
            variants={stagger}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.05 }}
        >
        <motion.p
            className="section-text"
            variants={itemVariant}>This Cookie Policy explains how ONBBITS ("we", "our", or "us") uses cookies and similar technologies.</motion.p>
        
        <motion.h2 className="section-heading" variants={fadeUp}>Cookies & analytics</motion.h2>
        <motion.ul variants={itemVariant}>
        <motion.li whileHover={{ x: 5 }} transition={{ duration: 0.2 }}>We use a small number of cookies.</motion.li>
        <motion.li whileHover={{ x: 5 }} transition={{ duration: 0.2 }}><strong>Essential cookies</strong> keep the website and your signed-in session working. These cannot be turned off.</motion.li>
        <motion.li whileHover={{ x: 5 }} transition={{ duration: 0.2 }}><strong>Your cookie choice</strong> is itself stored in a cookie named <strong>cookie_consent</strong>, which lasts up to 12 months, so we do not have to ask you on every visit. keep the website and your signed-in session working. These cannot be turned off.</motion.li>
        <motion.li whileHover={{ x: 5 }} transition={{ duration: 0.2 }}><strong>Analytics cookies</strong> are used only if you accept them. We use <strong>Google Analytics 4</strong> to understand how people use onbbits.io — which pages they visit and how far they scroll.</motion.li>
        <motion.li whileHover={{ x: 5 }} transition={{ duration: 0.2 }}>This sets cookies named <strong>_ga</strong> and <strong>_gid</strong>.</motion.li> 
        <motion.li whileHover={{ x: 5 }} transition={{ duration: 0.2 }}>Analytics are switched <strong>off by default</strong>: nothing is measured until you choose “Accept all” or turn analytics on under “Manage preferences”. Google processes this information as our analytics provider, and may do so outside your country. Google's own practices are described in its privacy documentation.</motion.li>
        <motion.li whileHover={{ x: 5 }} transition={{ duration: 0.2 }}><strong>Changing your mind.</strong> You can change or withdraw your cookie choice at any time using the <button type="button" className="cookie-preferences-link" onClick={() => window.dispatchEvent(new Event("openCookiePreferences"))}>Cookie preferences Link</button>{" "} here. Withdrawing is as easy as giving consent. You can also delete cookies in your browser settings.</motion.li>
        </motion.ul>
            
            <motion.h2 className="section-heading" variants={fadeUp}>1. What Are Cookies?</motion.h2>
             <motion.p
            className="section-text"
            variants={itemVariant}>Cookies are small text files stored on your device when you visit a website. They help websites function properly, remember your preferences, improve performance, and provide insights into how visitors use the site.</motion.p>

            <motion.h2 className="section-heading" variants={fadeUp}>2. How We Use Cookies</motion.h2>
            <motion.p
            className="section-text"
            variants={itemVariant}>We use cookies to:</motion.p>
             <motion.ul variants={itemVariant}>
                <motion.li
                whileHover={{ x: 5 }}
                transition={{ duration: 0.2 }}>Ensure our website functions correctly.</motion.li>
                <motion.li
                whileHover={{ x: 5 }}
                transition={{ duration: 0.2 }}>Improve website performance and user experience.</motion.li>
                <motion.li
                whileHover={{ x: 5 }}
                transition={{ duration: 0.2 }}>Remember your preferences and settings.</motion.li>
                <motion.li
                whileHover={{ x: 5 }}
                transition={{ duration: 0.2 }}>Analyze website traffic and visitor behavior.</motion.li>
                <motion.li
                whileHover={{ x: 5 }}
                transition={{ duration: 0.2 }}>Protect our forms from spam and abuse.</motion.li>
                <motion.li
                whileHover={{ x: 5 }}
                transition={{ duration: 0.2 }}>Measure the effectiveness of marketing campaigns where applicable.</motion.li>
            </motion.ul>

        <motion.h2 className="section-heading" variants={fadeUp}>3. Types of Cookies We Use</motion.h2>
         <motion.p
        className="section-text"
        variants={itemVariant}>We may use the following categories of cookies:</motion.p>
        <motion.ul variants={itemVariant}>
            <motion.li
            whileHover={{ x: 5 }}
            transition={{ duration: 0.2 }}><strong>Essential Cookies</strong> – Required for core website functionality and security.</motion.li>
            <motion.li
            whileHover={{ x: 5 }}
            transition={{ duration: 0.2 }}><strong>Analytics Cookies</strong> – Help us understand how visitors interact with our website (such as Google Analytics).</motion.li>
            <motion.li
            whileHover={{ x: 5 }}
            transition={{ duration: 0.2 }}><strong>Functional Cookies</strong> – Remember your preferences for a better browsing experience.</motion.li>
            <motion.li
            whileHover={{ x: 5 }}
            transition={{ duration: 0.2 }}><strong>Marketing Cookies</strong> – Used, where applicable, to measure advertising performance and deliver relevant content.</motion.li>
        </motion.ul>

        <motion.h2 className="section-heading" variants={fadeUp}>4. Third-Party Services</motion.h2>
         <motion.p
        className="section-text"
        variants={itemVariant}>Some cookies are placed by trusted third-party providers that help us operate our website. These may include:</motion.p>
        <motion.ul variants={itemVariant}>
            <motion.li
            whileHover={{ x: 5 }}
            transition={{ duration: 0.2 }}>Google Analytics</motion.li>
            <motion.li
            whileHover={{ x: 5 }}
            transition={{ duration: 0.2 }}>Google Tag Manager</motion.li>
            <motion.li
            whileHover={{ x: 5 }}
            transition={{ duration: 0.2 }}>Google reCAPTCHA</motion.li>
            <motion.li
            whileHover={{ x: 5 }}
            transition={{ duration: 0.2 }}>Google Ads</motion.li>
        </motion.ul>
        <motion.p
        className="section-text"
        variants={itemVariant}>These services are governed by their own privacy and cookie policies.</motion.p>

        <motion.h2 className="section-heading" variants={fadeUp}>5. Contact Us</motion.h2>
        <motion.p
        className="section-text"
        variants={itemVariant}>If you have any questions about this Cookie Policy or our use of cookies, please contact us:</motion.p>
        <motion.ul variants={itemVariant}>
            <motion.li
            whileHover={{ x: 5 }}
            transition={{ duration: 0.2 }}>Website: <a href="https://onbbits.io" tagret="_blank">onbbits.io</a></motion.li>
            <motion.li
            whileHover={{ x: 5 }}
            transition={{ duration: 0.2 }}>Email: <a href="mailto:info@onbbits.io">info@onbbits.io</a></motion.li>
        </motion.ul>
        </motion.section>

        {/**CTA SECTION */}
        <Cta />
        </>
    )
}
export default CookiePolicy;